import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import Colecciones from './modules/colecciones'
import Catalogo from './modules/catalogo'
import Venta from './modules/venta'
import Cotizacion from './modules/pedido'
import Clientes from './modules/cliente'
import Reserva from './modules/reserva'
import Promocion from './modules/promocion'
import Reportes from './modules/reportes'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    usuario: user,
    cols: Colecciones,
    cat: Catalogo,
    vnt: Venta,
    cot: Cotizacion,
    cli: Clientes,
    rsv: Reserva,
    promo: Promocion,
    rep: Reportes
  },
  state: {
    nota: false,
    notaContent: {color:'', texto: ''},
    letras: [
      '#',
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z'
    ]
  },
  mutations: {
    notaContent (state,  payload) {
      state.notaContent = payload
    },
    nota (state, payload) {
      state.nota = payload
    }
  },
  getters: {
    nota: (state) => state.nota,      
    notaContent: (state) => state.notaContent,
    letras: (state) => state.letras
  }
})
